import * as types from './types'
import projectApi from '../api'

export const actions = {
    async [types.PROJECT_FETCH]({commit}, data = null) {
        commit(types.PROJECT_SET_LOADING, true)
        const response = await projectApi.all(data)
        commit(types.PROJECT_OBTAIN, response.data.data)
        commit(types.PROJECT_META, response.data.meta)
        commit(types.PROJECT_SET_LOADING, false)
    },
}
